import React from "react";

import { useParams } from "react-router-dom";

import { HouseholdId } from "@fartherfinance/frontend/api/Households/types";

import HorizontalNavigation, {
  HorizontalNavigationTab,
} from "@src/multiCustodian/components/HorizontalNavigation/HorizontalNavigation";

enum HouseholdTab {
  ACCOUNTS = "Accounts",
  PROFILE = "Household",
  DOCUMENTS = "Documents",
}

export enum HouseholdTabPath {
  ACCOUNTS = "Accounts",
  PROFILE = "Profile",
  DOCUMENTS = "Documents",
}

interface Props {
  children: React.ReactNode;
}

const HouseholdsDrawerTabs: React.FC<Props> = ({ children }) => {
  const { householdId } = useParams<{
    householdId: HouseholdId;
  }>();

  const tabs: HorizontalNavigationTab[] = [
    {
      label: HouseholdTab.ACCOUNTS,
      path: `/Advisor/Households/${householdId}/${HouseholdTabPath.ACCOUNTS}`,
    },
    {
      label: HouseholdTab.PROFILE,
      path: `/Advisor/Households/${householdId}/${HouseholdTabPath.PROFILE}`,
    },
    // Note: Documents tab is de-scoped for V1
    // {
    //   label: HouseholdTab.DOCUMENTS,
    //   path: `/Advisor/Households/${householdId}/${HouseholdTabPath.DOCUMENTS}`,
    // },
  ];

  return <HorizontalNavigation tabs={tabs}>{children}</HorizontalNavigation>;
};

export default HouseholdsDrawerTabs;
